import { Component, QueryList, ContentChildren, AfterContentInit } from '@angular/core';
import { ChTabComponent } from './tab.component';


export class ChTabsComponent implements AfterContentInit {
  activeTab: string;
   tabs: QueryList<ChTabComponent>;
  constructor() { }
  ngAfterContentInit() {
    this.activeTab = this.tabs.first.id;
  }

  onSelect(id: string) {
    const tab = this.tabs.find(item => item.id === id);
    if (tab && !(tab.disabled === 'true')) {
      this.activeTab = id;
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'ch-tabs',
  template: "\n    <ul class=\"ch-tabs\"><li *ngFor=\"let tab of tabs\" [ngClass]=\"{active: tab.id == activeTab}\" [class.disabled]=\"tab.disabled==='true'\" (click)=\"onSelect(tab.id)\"><a><ng-container *ngIf=\"!tab.title\" [ngTemplateOutlet]=\"tab.titleTpl?.templateRef\"></ng-container><span *ngIf=\"tab.title\">{{tab.title}}</span></a></li></ul><div class=\"tab-content\"><ng-container *ngFor=\"let tab of tabs\"><div class=\"tab-pane active\" *ngIf=\"tab.id == activeTab\"><ng-template [ngTemplateOutlet]=\"tab?.contentTpl?.templateRef\"></ng-template></div></ng-container></div>\n  ",
  styles: ["\n    .ch-tabs{list-style:none;border-bottom:1px solid rgba(0,0,0,.12)}.ch-tabs li{line-height:48px;height:48px;padding:0 12px;cursor:pointer;box-sizing:border-box;opacity:.6;min-width:160px;text-align:center;display:inline-block;vertical-align:top;text-decoration:none;position:relative;overflow:hidden}.ch-tabs li a{color:#000}.ch-tabs .active{border-bottom:2px solid #197dbf}.ch-tabs .disabled{cursor:no-drop}.ch-tabs .disabled a{cursor:no-drop}.tab-content{overflow:hidden}\n  "]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'tabs': [{ type: ContentChildren, args: [ChTabComponent, ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
